// ABOUTME: The length of one v28 design pixel on the impact screens (3A, 4A, 4B before Forgive): the tiles and the rain size from it.
// ABOUTME: It follows the frame scale and the stack's scale, so a tile is 400 design pixels wide at v28's stack scale.

import { STACK_ROOT } from '../clouds/stackGeometry';

// v28's scale(0.8186) on the stack (SPEC 4): at that scale one design pixel is the frame scale's pixel.
export const IMPACT_REFERENCE_STACK_SCALE = 0.8186;

// A length, not a bare number: calc(var(--impact-px) * 400) must be a length for width, gap and background-size.
export const impactPx = (frameSc: number) => `${(frameSc * STACK_ROOT.scale) / IMPACT_REFERENCE_STACK_SCALE}px`;
